<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4>Histórico de Preços</h4>
  </div>

  <div class="card shadow-sm mb-4">
    <div class="card-body" [formGroup]="form">
      <div class="row g-3">
        <div class="col-md-3">
          <label for="dataInicio" class="form-label">Data Início</label>
          <input type="date" id="dataInicio" class="form-control" formControlName="dataInicio" style="background-color: #e9ecef;">
        </div>
        <div class="col-md-3">
          <label for="precoCusto" class="form-label">Preço de Custo</label>
          <input type="number" id="precoCusto" class="form-control" formControlName="precoCusto" (keydown)="calcularPrecoSugerido()">
        </div>
        <div class="col-md-2">
          <label for="custoFrete" class="form-label">Custo do Frete</label>
          <input type="number" id="custoFrete" class="form-control" formControlName="custoFrete" (keydown)="calcularPrecoSugerido()">
        </div>
        <div class="col-md-4">
          <label for="precoVenda" class="form-label">Preço de Venda</label>
          <input type="number" id="precoVenda" class="form-control" formControlName="precoVenda">
          <div class="form-text">
            Preço Sugerido: {{ precoSugerido | currency:'BRL' }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-primary" (click)="salvar()" [disabled]="form.invalid">Salvar</button>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-header">
      <h5 class="mb-0">Históricos Cadastrados</h5>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover mb-0" *ngIf="paginatedHistorico.length > 0; else noData">
        <thead class="thead-dark">
          <tr>
            <th>Data</th>
            <th>Preço de Custo</th>
            <th>Preço de Venda</th>
            <th>Custo do Frete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedHistorico">
            <td>{{ item.dataInicio | date:'dd/MM/yyyy' }}</td>
            <td>{{ item.precoCusto | currency:'BRL' }}</td>
            <td>{{ item.precoVenda | currency:'BRL' }}</td>
            <td>{{ item.custoFrete | currency:'BRL' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noData>
      <div class="card-body text-center">
        <p class="mb-0">Nenhum histórico de preço cadastrado para este produto.</p>
      </div>
    </ng-template>

    <div class="card-footer" *ngIf="totalPages > 1">
      <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center mb-0">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" href="#" (click)="$event.preventDefault(); goToPage(currentPage - 1)">Anterior</a>
          </li>
          <li class="page-item" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="i + 1 === currentPage">
            <a class="page-link" href="#" (click)="$event.preventDefault(); goToPage(i + 1)">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" href="#" (click)="$event.preventDefault(); goToPage(currentPage + 1)">Próxima</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-secondary" (click)="voltar()">Voltar</button>
  </div>
</div>
